import React from "react";

import {
  getCountryStateLabel,
  degreeOptions,
  getLabel
} from "../schema";

import EntryContainer from "./EntryContainer";
import IconButton from "./IconButton";

const ViewEducation = ({
  values,
  onEdit,
  onDelete,
  editing,
  noEdit,
  ...props
}) => {
  const { country, state } = getCountryStateLabel(
    values.country,
    values.state
  );
  const stateCountry = state === "" ? country : `${state}, ${country}`;
  const degree = getLabel(degreeOptions, values.degree);
  return (
    <EntryContainer disabled={editing} {...props}>
      <div className="d-flex justify-content-between">
        <div>
          <div className="header-text">{values.uniName}</div>
          <div>
            {`${degree}, ${values.major}`}
            {values.scholarship && ` (${values.scholarship} Scholarship)`}
          </div>
          <div className="sub-text">{`${values.from} – ${values.to}`}</div>
          <div className="sub-text">{stateCountry}</div>
        </div>
        {!noEdit && (
          <div>
            <IconButton onClick={onEdit} disabled={editing} icon="Pencil" />
          </div>
        )}
      </div>
    </EntryContainer>
  );
};

export default ViewEducation;
